module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0010.484e1f65.jpg";